import type { ApiResponse, GetListResponse } from '@gokrew/models/generic';
import api from './client';

import type {
  OnLeaveFilter,
  HolidayFilter,
  GetOnLeaveResponse,
  GetHolidaysResponse,
} from '@/types/dashboard';

import type { AnnouncementDetail } from '@gokrew/models/announcements';

export const getOnLeaveToday = async (params: OnLeaveFilter) => {
  const res = await api.get<GetOnLeaveResponse>(
    '/employee/dashboard/on-leaves',
    // v1 of this route is the mobile app's paginated list; the portal uses
    // the date-grouped v2.
    { params, baseURL: '/api/v2' }
  );

  return res.data;
};

export const getUpcomingHolidays = async (params: HolidayFilter) => {
  const res = await api.get<GetHolidaysResponse>(
    '/employee/dashboard/holidays',
    { params }
  );

  return res.data;
};

export const getDashboardAnnouncements = async (params: {
  page: number;
  limit: number;
}) => {
  const res = await api.get<GetListResponse<AnnouncementDetail>>(
    '/employee/dashboard/announcements',
    {
      params,
    }
  );

  return res.data;
};

export const getDashboardAnnouncementById = async (announcementId: string) => {
  const res = await api.get<ApiResponse<AnnouncementDetail>>(
    `/employee/dashboard/announcements/${announcementId}`
  );

  return res.data;
};
